import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.css']
})
export class CreateProductComponent {

  public pictureURL: string = '';
  private picture: File;

  constructor(private productsSerice: ProductsService) { }

  onPictureSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.picture = file;

    this.pictureURL = URL.createObjectURL(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (file) => {
      this.pictureURL = reader.result.toString();
    }
  }

  onCreateProduct(form: NgForm) {

    const product = new FormData();
    product.append('name', form.value.name);
    product.append('picture', this.picture);
    product.append('price', form.value.price);
    product.append('subscriptionPrice', form.value.subscriptionPrice);
    product.append('category', form.value.category);
    product.append('code', form.value.code);
    product.append('minimumWeight', form.value.minimumWeight);
    product.append('unitOfMeasurement', form.value.unitOfMeasurement);
    product.append('description', form.value.description);

    this.productsSerice.createProduct(product);
  }
}
